import { useState, useEffect } from 'react';
import { AppButton, AppTextField, PasswordInputField } from 'components';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';

const ManageRoles1 = ({ handleSave, userDetails = {}, roleKey }) => {
  const [name, setName] = useState('');
  const [email, handleEmail] = useState('');
  const [password, handlePassword] = useState('');
  const [formErrors, setFormErrors] = useState([]);

  useEffect(() => {
    if (userDetails?._id) {
      setName(userDetails?.name || '');
      handleEmail(userDetails?.email || '');
    }
  }, [userDetails]);

  function clear() {
    setName('');
    handleEmail('');
    handlePassword('');
  }

  function save(data = {}) {
    let validation;
    if (userDetails?._id) {
      validation = addAdminUserSchema.validate(data, {
        abortEarly: false,
        allowUnknown: true,
      });
    }

    validation = manageAdminUserSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    handleSave(data);
  }

  useEffect(() => {
    return () => {
      clear();
    };
  }, [roleKey]);

  const errors = checkForErrors(formErrors);

  return (
    <>
      <div className="col-lg-4 col-md-6 col-sm-12">
        <AppTextField
          labelProps={{
            label: 'Name *',
            htmlFor: 'name',
          }}
          inputProps={{
            placeholder: 'Name *',
            id: 'name',
            name: 'name',
            value: name,
            onChange: (event) => setName(event.target.value),
          }}
          fieldErrors={errors['email']}
        />
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12">
        <AppTextField
          labelProps={{
            label: 'Email *',
            htmlFor: 'email',
          }}
          inputProps={{
            placeholder: 'Email *',
            id: 'email',
            name: 'email',
            value: email,
            onChange: (event) => handleEmail(event.target.value),
          }}
          fieldErrors={errors['email']}
        />
      </div>
      {!userDetails?._id && (
        <div className="col-lg-4 col-md-6 col-sm-12">
          <PasswordInputField
            labelProps={{
              label: 'Password *',
              htmlFor: 'password',
            }}
            inputProps={{
              placeholder: 'Password *',
              id: 'password',
              name: 'password',
              value: password,
              onChange: (event) => handlePassword(event.target.value),
            }}
            fieldErrors={errors['password']}
          />
        </div>
      )}
      <div className="d-flex my-4">
        <AppButton
          variantClass="btn-primary mx-3"
          style={{ minWidth: '1.5rem' }}
          onClick={() => save({ email, password, name })}
        >
          Save
        </AppButton>
        {/* <AppButton variantClass="btn-primary mx-3" style={{ minWidth: '1.5rem' }} onClick={clear}>
          Cancel
        </AppButton> */}
      </div>
    </>
  );
};

const addAdminUserSchema = Joi.object({
  email: Joi.string().required(),
  name: Joi.string().required(),
  password: Joi.string().required().min(8),
});

const manageAdminUserSchema = Joi.object({
  email: Joi.string().required(),
  name: Joi.string().required(),
});

export default ManageRoles1;
